import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import {
  IoArrowBack,
  IoTimeOutline,
  IoCheckmarkCircleOutline,
  IoCloseCircleOutline,
  IoBriefcaseOutline,
  IoPersonOutline,
  IoBusinessOutline,
  IoCalendarOutline,
  IoRefresh
} from 'react-icons/io5';
import moment from 'moment';
import './ProveedorServiciosScreen.css';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';

// Componente: Badge de Estatus
const EstatusBadge = ({ estatus }) => {
  let className = 'service-status-badge';
  let texto = estatus.replace(/_/g, ' ');
  let icono = <IoTimeOutline />;

  if (['pendiente_proveedor', 'esperando_aprobacion_final'].includes(estatus)) {
    className += ' status-pendiente';
  } else if (['pendiente_residente', 'servicio_programado', 'proveedor_en_camino', 'proveedor_en_sitio', 'servicio_en_curso'].includes(estatus)) {
    className += ' status-proceso';
  } else if (['aceptada', 'servicio_terminado', 'completada'].includes(estatus)) {
    className += ' status-completada';
    icono = <IoCheckmarkCircleOutline />;
  } else if (['rechazada', 'cancelada', 'cancelado_con_cobro'].includes(estatus)) {
    className += ' status-cancelada';
    icono = <IoCloseCircleOutline />;
  }

  return (
    <span className={className}>
      {icono} <span style={{ textTransform: 'capitalize' }}>{texto}</span>
    </span>
  );
};

function ProveedorServiciosScreen() {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const [cotizaciones, setCotizaciones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userData || !userData.proveedorId) {
      if (userData && !userData.proveedorId) {
        setLoading(false);
        console.warn("Usuario logueado no tiene proveedorId vinculado.");
      }
      return;
    }

    const providerId = userData.proveedorId;
    setLoading(true);

    const q = query(
      collection(db, "cotizaciones"),
      where("proveedorId", "==", providerId),
      where("estatus", "in", [
        "pendiente_residente",
        "aceptada",
        "servicio_programado",
        "proveedor_en_camino",
        "proveedor_en_sitio",
        "esperando_aprobacion_final",
        "servicio_en_curso",
        "servicio_terminado",
        "completada",
        "rechazada",
        "cancelada",
        "cancelado_con_cobro"
      ]),
      orderBy("fechaCreacion", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaCotizaciones = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCotizaciones(listaCotizaciones);
      setLoading(false);
    }, (error) => {
      console.error("Error al cargar servicios: ", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userData]); 

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/proveedor/servicios" />
      <main className="ks-main">
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={false} />
        </div>
        <div className="ks-scroll-area">
          <div className="muro-header-stitch">
            <div className="muro-hero-card">
              <div className="muro-hero-content">
                <h1>Mis Servicios</h1>
                <p>Historial y Activos</p>
              </div>
              <IoBriefcaseOutline className="muro-hero-icon-decor" />
            </div>
          </div>
          <div className="provider-services-container">

      <div className="provider-services-content">
        {loading && (
          <div style={{ textAlign: 'center', padding: 50 }}>
            <div className="loader"></div>
            <p>Cargando tu historial...</p>
          </div>
        )}

        {!loading && cotizaciones.length === 0 && (
          <div className="empty-state-card">
            <IoBriefcaseOutline size={60} color="#94a3b8" />
            <h3 style={{ color: '#64748b', marginTop: 20 }}>Sin servicios aún</h3>
            <p style={{ color: '#94a3b8' }}>Tus servicios aceptados aparecerán aquí.</p>
          </div>
        )}

        {!loading && cotizaciones.length > 0 && (
          <div className="services-grid">
            {cotizaciones.map((coti) => (
              <div
                key={coti.id}
                className="service-card"
                onClick={() => navigate(`/proveedor/seguimiento/${coti.id}`)}
              >
                <div className="service-header-compact">
                  <div className="service-compact-info">
                    <h3>{coti.tipoServicio || "Servicio General"}</h3>
                    <div className="service-compact-sub">
                      <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><IoPersonOutline size={14} /> {coti.nombreResidente}</span>
                      <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><IoBusinessOutline size={14} /> {coti.nombreCondominio || "Condominio"}</span>
                    </div>
                  </div>
                  <div className="service-icon-stub">
                    <IoBriefcaseOutline />
                  </div>
                </div>

                <div className="service-footer-compact">
                  <div className="service-date-compact">
                    <IoCalendarOutline />
                    {coti.fechaCreacion?.toDate ? moment(coti.fechaCreacion.toDate()).format('D MMM YYYY') : 'N/A'}
                  </div>
                  <EstatusBadge estatus={coti.estatus} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      </div>
      </div>
      <KondoBottomNav activeRoute="/proveedor/servicios" />
      </main>
    </div>
  );
}

export default ProveedorServiciosScreen;